'use client';
import { Source } from 'react-map-gl';
import { TILESERVER_URL } from '../../constants';

export const SHARED_TILES_SOURCE_ID = 'shared-tiles';
interface SharedTilesSourceProps {
  children: React.ReactNode;
  stravaId: number;
  version: number;
}
export function SharedTilesSource({
  children,
  stravaId,
  version,
}: SharedTilesSourceProps) {
  return (
    <Source
      id={SHARED_TILES_SOURCE_ID}
      type="vector"
      url={`${TILESERVER_URL}/shared/${stravaId}/${version}/style.json`}>
      {children}
    </Source>
  );
}
